// Reducer function for basic details
import testingCommisionaAtionTypes from '../../actions/TestingCommission/TCActionTypes';

// Initial state for basic details
const initialBasicDetailsState = {
  isDateSetInEditMode: false,
  isEditMode: false,
  id: "",
  testingcommissionno: "",
  tcstatus: "",
  // basicDetails mandatory fields
  service: '',
  vendorname: '',
  typecode: '',
  workgroup: '',
  assetdesc: '',
  testingcommissionstartdate: "",
 //non mandatory fields
  location: '',
  model: '',
  serialno: "",
  chassisno: "",
  registerno: "",
  purchaseprice: "",
  purchaseorderno: "",
  financeassetno: '',
  manufacturer: '',
  warrantystartdate: "",
  warrantyexpirydate: "",
  isunderwarranty: "",
  lifespan: "",
  istestpassed: "",
  testingcommissioncompletedate: "",
  remarks: '',
  criticality: '',
  };

const basicDetailsReducer = (state = initialBasicDetailsState, action) => {
  switch (action.type) {
    case testingCommisionaAtionTypes.SET_BASIC_DETAILS_FIELDS:
      return {
        ...state,
        ...state.basicDetailsCreate,
        ...action.payload,
      };
    case testingCommisionaAtionTypes.RESET_BASIC_DETAILS_FIELDS:
      return initialBasicDetailsState;
    default:
      return state;
  }
};

export default basicDetailsReducer;
